import React, { useState, useEffect } from 'react';
import Img from 'img';
import Headline from 'headline';
import Smoke from 'components/shared/smoke-canvas';
import s from './high-slide.module.scss';

export default function HighSlide({ stage, index, stageName, images }) {
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    function handleCounter () {
      setCounter(counter === images.length -1 ? 0 : counter + 1);
      window[`timeout${index}`] = null;
    };
    if (!window[`timeout${index}`]) window[`timeout${index}`] = setTimeout(handleCounter, 5000);
  }, [counter, images.length, index]);

  return (
    <div
      className={`${s.root}`}
    >
      {/* <LazyLoad once> */}
      {images.map((el, i) => (
        <InnerSlide
          image={el}
          counter={counter}
          position={i}
          key={el}
          amount={images.length}
        />
      ))}

      {/* </LazyLoad> */}
      <div className={s.content}>
        <Headline>
          <span className={s.one}>EXHIBIT</span>
          <span className={s.two}>{stageName}</span>
        </Headline>
      </div>
      <Smoke />
    </div>
  );
}

function InnerSlide({ image, position, counter,amount, className }) {
  const classes = [
    s.one,
    s.two,
    s.three,
    s.four,
    s.five,
    s.six,
    s.seven,
    s.eight,
    s.nine,
    s.ten
  ];
  return (
    <div
      className={`
    ${s.imgWrapper}
    ${classes[position]}
    ${counter > position && s.opacityZero}
    ${position === 0 && counter === amount -1  && s.opacityZero}
    `}
    >
      <Img className={`${s.img}`} src={image} width={'100vw'} alt={image} />
    </div>
  );
}
